import StorageErrorModal, { ActionType } from '@anm/components/StorageErrorModal';
import checkIsStorageError from '@anm/helpers/checkIsStorageError';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userActions, userSelectors } from '../../../../store/modules/user';

type HookProps = {
  onSuccess: () => void;
  actionType: ActionType;
};

const useStorageError = ({ actionType, onSuccess }: HookProps) => {
  const [isCheck, setIsCheck] = useState(false);
  const [isStorageError, setIsStorageError] = useState<boolean>();

  const handleSuccess = () => {
    onSuccess();
    setIsStorageError(false);
  };

  const dispatch = useDispatch();
  const storageStats = useSelector(userSelectors.selectUserStorageStats);
  const isPending = storageStats?.isPending;

  const fetchStorage = () => {
    dispatch(userActions.fetchStorageStats());
    setIsCheck(true);
  };

  const cleanState = () => {
    dispatch(userActions.cleanStorageStats());
    setIsCheck(false);
  };

  useEffect(() => {
    if (!isCheck || !storageStats?.data) return;

    const { data } = storageStats;

    const isStorageError = checkIsStorageError({ storageStats: data });

    isStorageError ? setIsStorageError(true) : handleSuccess();
    cleanState();
  }, [isCheck, storageStats?.data]);

  const renderStorageModal = () =>
    isStorageError ? <StorageErrorModal actionType={actionType} onClose={() => setIsStorageError(false)} /> : null;

  return [fetchStorage, renderStorageModal, isPending] as const;
};

export default useStorageError;
